(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-nav-drawer]');
    var closeBtn = document.querySelector('[data-nav-close]');
    if (!toggle || !drawer) return;

    function openNav() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('nav-open');
    }

    function closeNav() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('nav-open');
    }

    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) {
        closeNav();
      } else {
        openNav();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeNav);
    }

    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeNav();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeNav();
      }
    });
  }

  function updateCartCount(count) {
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function (el) {
      var n = typeof count === 'number' ? count : parseInt(el.getAttribute('data-cart-count') || '0', 10);
      el.textContent = String(n);
      el.hidden = n < 1;
      el.classList.toggle('is-empty', n < 1);
    });
  }

  function initCartForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        /* Native submit — Shopify handles redirect / AJAX depending on form */
      });
    });
  }

  function initProductGallery(section) {
    var gallery = section.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var viewport = gallery.querySelector('[data-gallery-viewport]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (!viewport || slides.length < 2) return;

    var index = Math.max(
      0,
      slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      })
    );
    var scrolling = false;

    function clamp(value) {
      if (value < 0) return 0;
      if (value > slides.length - 1) return slides.length - 1;
      return value;
    }

    function syncUi(activeIndex) {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === activeIndex);
      });
      thumbs.forEach(function (thumb, i) {
        var active = i === activeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (prevBtn) prevBtn.disabled = activeIndex === 0;
      if (nextBtn) nextBtn.disabled = activeIndex === slides.length - 1;
    }

    function goTo(nextIndex, smooth) {
      index = clamp(nextIndex);
      var slide = slides[index];
      if (!slide) return;
      scrolling = true;
      viewport.scrollTo({
        left: slide.offsetLeft,
        behavior: smooth === false ? 'auto' : 'smooth'
      });
      syncUi(index);
      window.setTimeout(function () {
        scrolling = false;
      }, 350);
    }

    function indexFromScroll() {
      var nearest = 0;
      var nearestDistance = Infinity;
      slides.forEach(function (slide, i) {
        var distance = Math.abs(slide.offsetLeft - viewport.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearest = i;
        }
      });
      return nearest;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var thumbIndex = parseInt(thumb.getAttribute('data-index') || '0', 10);
        goTo(thumbIndex);
      });
    });

    viewport.addEventListener('scroll', function () {
      if (scrolling) return;
      var nextIndex = indexFromScroll();
      if (nextIndex === index) return;
      index = nextIndex;
      syncUi(index);
    });

    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(index + 1);
      }
    });

    goTo(index, false);
  }

  function initProductPage() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;

    var variantInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-product-price]');
    var addBtn = section.querySelector('[data-add-to-cart]');
    var addLabel = section.querySelector('[data-add-label]');
    var addPrice = section.querySelector('[data-add-price]');
    var subtitle = section.querySelector('[data-product-subtitle]');
    var soldOutLabel = 'Sold out';
    var addPrefix = 'Add to bag';
    var stockEl = section.querySelector('[data-stock-signal]');
    var stockTitle = section.querySelector('[data-stock-title]');
    var stockDetail = section.querySelector('[data-stock-detail]');
    var inStockLabel = stockEl ? stockEl.getAttribute('data-in-stock-label') || 'In stock' : 'In stock';
    var readyLabel = stockEl ? stockEl.getAttribute('data-ready-label') || 'Ready to dispatch' : 'Ready to dispatch';
    var outOfStockLabel = stockEl ? stockEl.getAttribute('data-out-of-stock-label') || 'Out of stock' : 'Out of stock';

    function updateStock(available) {
      if (!stockEl) return;
      stockEl.classList.toggle('is-available', available);
      stockEl.classList.toggle('is-unavailable', !available);
      if (stockTitle) stockTitle.textContent = available ? inStockLabel : outOfStockLabel;
      if (stockDetail) {
        stockDetail.textContent = available ? readyLabel : '';
        stockDetail.hidden = !available;
      }
    }

    initProductGallery(section);

    var qtyWrap = section.querySelector('[data-qty]');
    if (qtyWrap) {
      var qtyInput = qtyWrap.querySelector('[data-qty-input]');
      var decrease = qtyWrap.querySelector('[data-qty-decrease]');
      var increase = qtyWrap.querySelector('[data-qty-increase]');

      function clampQty(value) {
        var n = parseInt(value, 10);
        if (isNaN(n) || n < 1) n = 1;
        return n;
      }

      if (decrease) {
        decrease.addEventListener('click', function () {
          qtyInput.value = String(Math.max(1, clampQty(qtyInput.value) - 1));
        });
      }
      if (increase) {
        increase.addEventListener('click', function () {
          qtyInput.value = String(clampQty(qtyInput.value) + 1);
        });
      }
      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          qtyInput.value = String(clampQty(qtyInput.value));
        });
      }
    }

    section.querySelectorAll('[data-variant-option]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        var available = input.getAttribute('data-available') === 'true';
        var priceFormatted = input.getAttribute('data-price-formatted') || '';
        var title = input.getAttribute('data-title') || '';
        var mediaId = input.getAttribute('data-media-id');

        if (variantInput) variantInput.value = input.value;
        if (priceEl) priceEl.textContent = priceFormatted;

        section.querySelectorAll('.main-product__pill').forEach(function (pill) {
          pill.classList.toggle('is-selected', pill.contains(input));
        });

        if (subtitle && title && title !== 'Default Title') {
          var parts = subtitle.textContent.split('•');
          if (parts.length > 1) {
            subtitle.textContent = parts[0].trim() + ' • ' + title;
          }
        }

        if (mediaId) {
          var thumb = section.querySelector('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
          if (thumb) thumb.click();
        }

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url.toString());
        }

        if (addBtn) addBtn.disabled = !available;
        updateStock(available);
        if (addLabel) {
          if (available) {
            addLabel.innerHTML =
              addPrefix +
              ' — <span data-add-price>' +
              priceFormatted +
              '</span>';
          } else {
            addLabel.textContent = soldOutLabel;
          }
        } else if (addPrice) {
          addPrice.textContent = priceFormatted;
        }
      });
    });
  }

  function initCartQuantity() {
    var cartForm = document.querySelector('[data-cart-form]');
    if (!cartForm) return;

    cartForm.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    function changeQty(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          window.location.reload();
        });
    }

    cartForm.querySelectorAll('[data-cart-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-qty-input]');
      var decrease = wrap.querySelector('[data-qty-decrease]');
      var increase = wrap.querySelector('[data-qty-increase]');
      var key = wrap.getAttribute('data-line-key');
      if (!input || !key) return;

      function currentQty() {
        var n = parseInt(input.value, 10);
        if (isNaN(n) || n < 0) n = 0;
        return n;
      }

      if (decrease) {
        decrease.addEventListener('click', function () {
          changeQty(key, Math.max(0, currentQty() - 1));
        });
      }
      if (increase) {
        increase.addEventListener('click', function () {
          changeQty(key, currentQty() + 1);
        });
      }
      input.addEventListener('change', function () {
        changeQty(key, currentQty());
      });
    });
  }

  ready(function () {
    initMobileNav();
    initCartForms();
    initCartQuantity();
    initProductPage();

    fetch('/cart.js')
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          updateCartCount(cart.item_count);
        }
      })
      .catch(function () {});
  });

  window.StayPosh = {
    updateCartCount: updateCartCount
  };
})();
